// @file Entrypoint for auth signup page
import { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import { useAuthSignupStore } from '@@/pinia/auth_signup_store'
import AuthSignupApp from '@@/vuecomponents/AuthSignupApp.vue'
import { configure as configureArvo } from '@padlet/arvo'

async function configureApi(): Promise<void> {
  const { arvoConfig } = ww.vueStartingState
  void configureArvo(arvoConfig)
}

void setupVueApp({
  el: '#auth_signup_app',
  rootComponent: AuthSignupApp,
  beforeMountPromises: [configureApi()],
  usePinia: true,
  initializePiniaStore() {
    useAuthSignupStore().initialize(ww.vueStartingState)
  },
})
